import { Component, Input, OnInit } from '@angular/core';
import { CartGroupValueItem } from '../../../../../models/cart-group-value-item.model';
import { FaDirectiveEnum } from '../../../../../models/enums/fa-directive.enum';

@Component({
  selector: 'jhi-cart-group-value[items][label][value]',
  templateUrl: './cart-group-value.component.html',
  styleUrls: ['./cart-group-value.component.scss'],
})
export class CartGroupValueComponent implements OnInit {
  @Input() label!: string;
  @Input() color = 'color-gray';
  @Input() currency = 'EUR';
  @Input() suffix?: 'HT' | 'TTC';
  @Input() options!: { withCurrency: boolean };
  @Input() value!: any;
  @Input() items?: CartGroupValueItem[] = [];

  public collapsed = true;

  protected readonly FAS = FaDirectiveEnum.FAS;

  private _defaultOptions: { withCurrency: boolean } = { withCurrency: true };

  ngOnInit(): void {
    this.options = { ...this._defaultOptions, ...this.options };
  }
}
